import { css } from 'styled-components';

const dark = css``;

const light = css`
  background-color: var(--bob-core-components-color-mint20);
  box-shadow: 0 0 0.25rem 0.0625rem var(--bob-core-components-color-ash),
    0 0 0.0625rem 0 var(--bob-core-components-color-coal),
    0 0 0.5rem 0.0625rem var(--bob-core-components-color-violet);
`;

export default { dark, light };
